import React, { useState, useRef, useEffect } from "react";
import {
  Menu,
  Grid,
  Select,
  MenuItem,
  IconButton,
  FormControl,
  CircularProgress,
} from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Calendar from "../../../components/calendar/Calender";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const CustomerdetailThaThcc = () => {
  const [product, setProduct] = useState<string>("THA");
  const [simData, setSimData] = useState(null);
  const agGridRef = useRef<AgGridReact | null>(null);
  const [selectedStartDate, setSelectedStartDate] = useState<Dayjs | null>(
    dayjs().add(-30, "days"),
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Dayjs | null>(dayjs());
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [calendarOpen, setCalendarOpen] = useState(false);

  useEffect(() => {
    if (selectedStartDate && selectedEndDate) {
      const startDateParam = selectedStartDate.format("YYYY-MM-DD");
      const endDateParam = selectedEndDate.add(1, "days").format("YYYY-MM-DD");
      setSimData(null);
      GetSimData(startDateParam || "", endDateParam || "");
    }
  }, [selectedStartDate, selectedEndDate, product]);

  const exportGridDataAsCSV = () => {
    if (agGridRef.current) {
      agGridRef.current.api.exportDataAsCsv();
    }
  };

  const columnDefs: ColDef[] = [
    {
      field: "ID",
      headerName: "User Id",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "FirstName",
      headerName: "First Name",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "LastName",
      headerName: "Last Name",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "Email",
      headerName: "Email",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "msisdn",
      headerName: "Msisdn",
      filter: true,
      sortable: true,
      resizable: true,
    },
    {
      field: "CreatedDateTime",
      headerName: "Created Date",
      filter: true,
      sortable: true,
      resizable: true,
    },
  ];

  const onGridReady = (params: { api: { sizeColumnsToFit: () => void } }) => {
    params.api.sizeColumnsToFit();
  };

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const toggleCalendar = () => {
    setCalendarOpen(!calendarOpen);
    handleMenuClose();
  };

  const handleStartDateChange = (date: Dayjs | null) => {
    if (date !== null && date.isValid()) {
      setSelectedStartDate(date);
    }
  };

  const handleEndDateChange = (date: Dayjs | null) => {
    if (date !== null && date.isValid()) {
      setSelectedEndDate(date);
    }
  };

  const GetSimData = async (startDate: string, endDate: string) => {
    await axiosInterceptorInstance
      .get(
        `/dashboard/CustomerDetailTHATHCC?StartDate=${startDate}&EndDate=${endDate}&Product=${product}`,
      )
      .then((response) => {
        const responseData = JSON.parse(response.data.body);
        if (responseData.Data.length > 0) {
          setSimData(responseData.Data);
        } else {
          toast.info("Record Not found");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div>
        <h2 className="heading">Customer Detail</h2>
        {selectedEndDate &&
          selectedStartDate &&
          Math.floor(selectedEndDate.diff(selectedStartDate, "day", true)) ===
            30 && <span className="small-text">Last 30 Days</span>}
      </div>

      <Grid container spacing={1} style={{ justifyContent: "end" }}>
        <Grid item xs={3}>
          <FormControl style={{ width: "100%", backgroundColor: "white" }}>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              className="selectControl"
              autoWidth
              value={product}
              defaultValue={product}
              onChange={(e: any) => {
                setSimData(null);
                setProduct(e.target.value);
              }}
            >
              <MenuItem value="THA">THA</MenuItem>
              <MenuItem value="THCC">THCC</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <IconButton
            onClick={(e: any) => {
              if (simData) {
                handleMenuClick(e);
              }
            }}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={toggleCalendar}></MenuItem>
            {selectedStartDate && selectedEndDate && (
              <Calendar
                selectedStartDate={selectedStartDate}
                selectedEndDate={selectedEndDate}
                onStartDateChange={handleStartDateChange}
                onEndDateChange={handleEndDateChange}
              />
            )}
          </Menu>
        </Grid>
      </Grid>

      {simData && (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <button
              className="small-btn"
              style={{
                visibility: simData ? "visible" : "hidden",
                marginTop: "15px",
                marginBottom: "10px",
              }}
              onClick={() => {
                if (simData) {
                  exportGridDataAsCSV();
                }
              }}
            >
              Export as CSV
            </button>
          </div>
        </div>
      )}
      {!simData && (
        <div className="dummy-conatiner">
          <CircularProgress size={40} />
        </div>
      )}

      {simData && (
        <div className="ag-theme-alpine">
          <AgGridReact
            ref={agGridRef}
            paginationPageSize={12}
            pagination={true}
            domLayout="autoHeight"
            rowData={simData}
            columnDefs={columnDefs}
            enableCellTextSelection={true}
            onGridReady={onGridReady}
          ></AgGridReact>
        </div>
      )}
    </motion.div>
  );
};

export default CustomerdetailThaThcc;
